<template>
    <div>
        <el-dialog
                :title="dialogTitle"
                :visible.sync="dialogVisible"
                width="65%"
                :fullscreen="windowWidth < 700">

            <el-table
                    :data="tableData"
                    class="w-full"
                    @selection-change="handleSelectionChange"
                    @sort-change="sort"
                    :default-sort = "{prop: 'date', order: 'ascending'}">

                <!-- Selection -->
                <el-table-column v-if="!readOnly"
                        type="selection"
                        width="50"
                        :selectable="maySelect">
                </el-table-column>

                <!-- datum -->
                <el-table-column
                        sortable="custom"
                        prop="date"
                        label="Datum">
                    <template slot-scope="scope">
                        {{ moment(scope.row.date).format('DD-MM-YYYY') }}
                    </template>
                </el-table-column>

                <!-- startTime -->
                <el-table-column
                        sortable="custom"
                        prop="startTime"
                        label="Start"
                        width="80">
                    <template slot-scope="scope">
                        {{ moment(scope.row.startTime).format('HH:mm') }}
                    </template>
                </el-table-column>

                <!-- endTime -->
                <el-table-column
                        sortable="custom"
                        prop="endTime"
                        label="Einde"
                        width="85">
                    <template slot-scope="scope">
                        {{ moment(scope.row.endTime).format('HH:mm') }}
                    </template>
                </el-table-column>

                <!-- branch -->
                <el-table-column
                        sortable="custom"
                        prop="branch"
                        label="Tak">
                    <template slot-scope="scope">
                        <el-tag size="medium">{{ getBranchName(scope.row.branchId) }}</el-tag>
                    </template>
                </el-table-column>

                <!-- status -->
                <el-table-column
                        sortable="custom"
                        prop="sessionStatus"
                        label="Status"
                        v-if="windowWidth > 700">
                    <template slot-scope="scope">
                        <el-tag size="medium" :type="getType(scope.row.sessionStatus)">{{ getName(scope.row.sessionStatus) }}</el-tag>
                    </template>
                </el-table-column>

                <el-table-column
                        v-if="windowWidth > 700"
                        width="40">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.annotation" placement="top-start" v-if="scope.row.annotation">
                            <i class="el-icon-more"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>

                <!-- Operations column -->
                <el-table-column label="Operaties" v-if="windowWidth > 700" width="300">
                    <template slot-scope="scope">
                        <el-button :disabled="scope.row.sessionStatus != 'SESSION_IN_PROGRESS'"
                                size="mini"
                                @click="handleEdit(scope.$index, scope.row)">Wijzigen</el-button>
                      <el-button size="mini" v-if="!readOnly"
                                 @click="showHistory(scope.$index, scope.row)">History</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="mt-6">
                <el-row :gutter="10">
                    <el-col :span="12">
                        <div v-if="!readOnly">
                            <el-dropdown trigger="click" @command="setStatus">
                                <el-button type="primary">
                                    Status<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="SESSION_CANCELLED" :disabled="!(this.$store.getters.isRepresentative || this.$store.getters.isTreasurer || this.$store.getters.isAdmin)">Verwerpen</el-dropdown-item>
                                    <el-dropdown-item command="SESSION_IN_PROGRESS">Nieuw</el-dropdown-item>
                                    <el-dropdown-item command="SESSION_CONFIRMED" :disabled="!this.$store.getters.isRepresentative">Bevestigen</el-dropdown-item>
                                    <el-dropdown-item command="SESSION_PAID" :disabled="!this.$store.getters.isTreasurer">Uitbetaald</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>

                            <el-button type="danger" class="ml-2" @click="handleDelete">Verwijderen</el-button>
                        </div>
                        <div v-else>
                            <el-button type="primary" class="ml-2" @click="handleAdd" icon="el-icon-plus">Toevoegen</el-button>
                        </div>
                    </el-col>

                    <el-col :span="6">
                          <el-tooltip class="item" effect="dark"
                                      content="Datum geleverde prestaties" placement="top">
                          <el-date-picker
                            v-model="selectedMonth"
                            type="month"
                            placeholder="Kies maand"
                            class="mb-2 w-full"
                            @change="changeDateRange"
                            :clearable="false">
                          </el-date-picker>
                          </el-tooltip>
                    </el-col>

                    <el-col :span="6">
                        <el-tooltip class="item" effect="dark"
                                    content="Aantal niet-verworpen uren" placement="top">
                            <el-input :readonly="true"
                                      prefix-icon="el-icon-time"
                                      :value="getNumHours">
                                <template slot="append">uur</template>
                            </el-input>
                        </el-tooltip>
                    </el-col>
                </el-row>
            </div>

            <!-- Footer -->
            <span slot="footer" class="dialog-footer">

                <div v-if="readOnly">
                    <el-button @click="dialogVisible = false">Sluiten</el-button>
                </div>
                <div v-else>
                    <el-button @click="dialogVisible = false">Annuleer</el-button>
                    <el-button type="primary" @click="save()" :loading="loading">Opslaan</el-button>
                </div>
            </span>
        </el-dialog>

        <performance-dialog ref="addEditDialog" :branch-options="branchOptions"></performance-dialog>
        <performance-history-dialog ref="historyDialog"></performance-history-dialog>
    </div>
</template>

<script>
    import moment from "moment"
    import PerformanceDialog from "./PerformanceDialog";
    import PerformanceHistoryDialog from "./PerformanceHistoryDialog";
    export default {
        name: "PerformancesOverviewDialog",
        components: {PerformanceDialog, PerformanceHistoryDialog},
        props: {
            branchOptions: {
                type: Array
            },

            readOnly: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                dialogTitle: "",
                itemName: "prestatie",
                dialogVisible: false,
                multipleSelection: [],
                loading: false,
                userId: null,
                firstDay: null,
                lastDay: null,
                selectedMonth: new Date(),
                num: 0,
                canSelect: this.computeCanSelect(),
                windowWidth: window.innerWidth,

                // Table data
                tableData: [],
                numPages: 1,
                pageSize: 10,
                currentPage: 1,
                pageSizes: [10, 20, 50],
                totalElements: 0
            }
        },
        methods: {
            toggleSelection(rows) {
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                } else {
                    this.$refs.multipleTable.clearSelection();
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            setStatus(status) {
                const that = this;
                this.multipleSelection.forEach(function(item) {
                    item.sessionStatus = status;
                });
            },
            handleDelete() {
                this.$confirm(`Het verwijderen van deze ${this.itemName}(s) is een actie die niet ongedaan kan worden gemaakt. Bent u zeker dat u deze ${this.itemName}(s) wil verwijderen?` , `${this.capitalize(this.itemName)} verwijderen`, {
                    confirmButtonText: 'Verwijderen',
                    cancelButtonText: 'Annuleer',
                    customClass: "p-4",
                }).then(() => {
                    this.num = this.multipleSelection.length
                    const that = this;
                    this.multipleSelection.forEach(function(item) {
                        that.$http.delete(`admin/sessions/${item.id}`).then((response) => {
                            that.num = that.num-1;
                            if(that.num === 0) {
                                that.$notify({
                                    title: `${that.capitalize(that.itemName)}(s) verwijderd`,
                                    message: `${that.capitalize(that.itemName)}(s) werden successvol verwijderd.`,
                                    type: 'success'
                                });
                                that.getList();
                            }

                        }).catch((error) => {
                            that.$message({
                                showClose: true,
                                message: `Kon ${that.itemName} niet verwijderen`,
                                type: 'error'
                            });
                            console.log(error);
                        })
                    });
                })
            },
            handleAdd() {
                this.$refs.addEditDialog.add();
            },
            objAdded(obj) {
                // Add API call here
                this.$http.post('sessions', obj).then((response) => {
                    this.$notify({
                        title: `${this.capitalize(this.itemName)} toegevoegd`,
                        message: `${this.capitalize(this.itemName)} werd successvol toevoegd.`,
                        type: 'success'
                    });
                    this.$refs.addEditDialog.close();
                    this.getList();
                }).catch((error) => {
                    this.$refs.addEditDialog.openAlert(`Kon ${this.itemName} niet toevoegen`, 'error')
                    console.log(error);
                })
            },
            handleEdit(index, row) {
                this.$refs.addEditDialog.edit(row)
            },
            showHistory(index, row) {
                this.$refs.historyDialog.showHistory(row)
            },
            objEdited(obj) {
                if (this.readOnly) {
                    this.$http.put(`sessions/${obj.id}`, obj).then((response) => {
                        // Add API call here
                        this.$notify({
                            title: `${this.capitalize(this.itemName)} gewijzigd`,
                            message: `${this.capitalize(this.itemName)} werd successvol gewijzigd.`,
                            type: 'success'
                        });
                        this.$refs.addEditDialog.close();
                        this.getList();
                    }).catch((error) => {
                        this.$message({
                            showClose: true,
                            message: `Kon ${that.itemName} niet wijzigen`,
                            type: 'error'
                        });
                        console.log(error);
                    })
                } else {
                    this.$http.put(`admin/sessions/${obj.id}`, obj).then((response) => {
                        // Add API call here
                        this.$notify({
                            title: `${this.capitalize(this.itemName)} gewijzigd`,
                            message: `${this.capitalize(this.itemName)} werd successvol gewijzigd.`,
                            type: 'success'
                        });
                        this.$refs.addEditDialog.close();
                        this.getList();
                    }).catch((error) => {
                        this.$message({
                            showClose: true,
                            message: `Kon ${that.itemName} niet wijzigen`,
                            type: 'error'
                        });
                        console.log(error);
                    })
                }
            },
            changeDateRange(dstDate) {
                this.firstDay = this.getMonth.firstDay
                this.lastDay = this.getMonth.lastDay
                this.getList()
            },
            show(user, firstDay, lastDay) {
                this.dialogTitle = `Prestaties ${user.firstName} ${user.lastName}`
                this.dialogVisible = true
                this.userId = user.id;
                this.firstDay = firstDay;
                this.lastDay = lastDay;
                this.getList();
            },
            close() {
                this.loading = false;
                this.dialogVisible = false;
            },
            sort (props) {
                if (props.order === 'ascending') {
                    this.sortDir = 'ASC'
                } else {
                    this.sortDir = 'DESC'
                }
                this.sortBy = props.prop
                this.getList()
            },
            getList() {
                let params = {}
                if (this.sortDir != null && this.sortBy != null) {
                    params['sortBy'] = this.sortBy
                    params['sortDir'] = this.sortDir
                }

                if (this.readOnly) {
                    this.$http.get(`sessions?startDate=${this.firstDay}&endDate=${this.lastDay}`, {
                        params: params
                    }).then((response) => {
                        const listResponse = response.data
                        this.tableData = listResponse;
                        this.totalElements = response.data.totalElements
                    }).catch(function (error) {
                        console.log(error)
                    })
                } else {
                    this.$http.get(`admin/sessions?user=${this.userId}&startDate=${this.firstDay}&endDate=${this.lastDay}`, {
                        params: params
                    }).then((response) => {
                        const listResponse = response.data
                        this.tableData = listResponse;
                        this.totalElements = response.data.totalElements
                    }).catch(function (error) {
                        console.log(error)
                    })
                }
            },
            capitalize(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            },
            getName(status) {
                switch(status) {
                    case "SESSION_CANCELLED":
                        return 'Verworpen'
                    case "SESSION_IN_PROGRESS":
                        return 'Nieuw'
                    case "SESSION_CONFIRMED":
                        return 'Bevestigd'
                    case "SESSION_PAID":
                        return 'Betaald'
                    default:
                        return 'Onbekend'
                }
            },
            getType(status) {
                switch(status) {
                    case "SESSION_CANCELLED":
                        return 'danger'
                    case "SESSION_IN_PROGRESS":
                        return 'primary'
                    case "SESSION_CONFIRMED":
                        return 'warning'
                    case "SESSION_PAID":
                        return 'success'
                    default:
                        return 'primary'
                }
            },
            save() {
                this.num = this.multipleSelection.length
                const that = this;

                if(this.num === 0) {
                    that.dialogVisible = false;
                    return
                }

                this.loading = true;
                this.multipleSelection.forEach(function(item) {
                    that.$http.put(`admin/sessions/${item.id}`, item).then((response) => {
                        that.num = that.num-1;
                        if(that.num === 0) {
                            that.$notify({
                                title: `${that.capitalize(that.itemName)}(s) gewijzigd`,
                                message: `${that.capitalize(that.itemName)}(s) werden successvol gewijzigd.`,
                                type: 'success'
                            });
                            that.getList();
                            that.loading = false;
                            that.$parent.updateList();
                            that.dialogVisible = false;
                        }

                    }).catch((error) => {
                        that.$message({
                            showClose: true,
                            message: `Kon ${that.itemName} niet wijzigen`,
                            type: 'error'
                        });
                        console.log(error);
                    })
                });
            },
            maySelect(row, index) {
                // return this.canSelect.contains(row.sessionStatus)cons
                return this.canSelect.includes(row.sessionStatus)
            },
            getBranchName: function (id) {
                if(this.branchOptions) {
                    const branch = this.branchOptions.find(function(branch) {
                        return branch.id === id;
                    });

                    return branch.label
                }
            },
            computeCanSelect() {
                const selectable = []
                if(this.$store.getters.isRepresentative) {
                    selectable.push("SESSION_IN_PROGRESS")
                    selectable.push("SESSION_CANCELLED")
                }
                if(this.$store.getters.isTreasurer) {
                    selectable.push("SESSION_CONFIRMED")
                }
                if(this.$store.getters.isAdmin) {
                    selectable.push("SESSION_PAID")
                }
                return selectable
            }
        },
        mounted() {
            window.onresize = () => {
                this.windowWidth = window.innerWidth
            }
        },
        computed: {
            getNumHours() {
                let numHours = 0;

                this.tableData.forEach(function(session) {
                    if(session.sessionStatus !== 'SESSION_CANCELLED'){
                        var start = moment(session.date).toDate();
                        start.setHours(moment(session.startTime).hours())
                        start.setMinutes(moment(session.startTime).minutes())

                        var end = moment(session.date).toDate();
                        end.setHours(moment(session.endTime).hours())
                        end.setMinutes(moment(session.endTime).minutes())

                        var duration = moment.duration(moment(end).diff(start));
                        numHours += duration.asHours();
                    }
                });

                return numHours.toFixed(2);
            },
            getMonth() {
                const y = this.selectedMonth.getFullYear()
                const m = this.selectedMonth.getMonth()
                let firstDay = new Date(y, m, 1);
                let lastDay = new Date(y, m + 1, 0);

                firstDay = moment(firstDay).format("D-MM-YYYY")
                lastDay = moment(lastDay).format("D-MM-YYYY")

                return {
                    firstDay: firstDay,
                    lastDay: lastDay
                };
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/prestations/dialogs/PerformancesOverviewDialog.vue